module.exports = __webpack_public_path__ + "img/conclusion2.ea0a1732.svg";